<template>
    <div class="login-user">
        <div class="index-view-top">
            <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
            <div class="title">{{ $t("phone.title") }}</div>
            <van-icon style="opacity: 0" />
        </div>
        <div class="login-main">
            <div class="exchange-number" style="color:#ffffff">
                <div class="left-title" style="min-width: 3rem;
            max-width: 3rem;">{{ $t("phone.phone") }}</div>
                +
                <div class="select-icon">
                    <p @click="openIconShow">{{ value }}</p>
                    <van-icon @click="openIconShow" name="arrow-down" size="20" color="#ffffff" />
                    <div class="select-up" v-if="iconShow == true">
                        <div @click="changeValue(item.code)" v-for="(item, index) in options" :key="index">
                            <p :class="value == item.code ? 'active' : ''">+{{ item.code + ' ' + item.name }}</p>
                        </div>
                    </div>
                </div>
                <van-cell-group inset style="margin: 0; width: 90%">
                    <van-field v-model="phone" type="number" :placeholder="tips1" />
                </van-cell-group>
            </div>
            <div class="exchange-number">
                <div class="left-title">{{ $t("phone.code") }}</div>
                <van-cell-group inset style="margin: 0; width: 90%">
                    <van-field v-model="code" maxlength="6" type="number" :placeholder="tips2" />
                </van-cell-group>
                <div @click="getCode" class="left-title" style="padding: 0 0.25rem 0;text-align: right;">{{ codeStatus
                        == true ?
                        countdown + 's' :
                        $t("phone.getCode")
                }}</div>
            </div>
            <div class="nowLogin" @click="toBind">
                <div>
                    <p>{{ $t("login.confirm") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSms, phoneCode, bindPhone } from "@/utils/request";
export default {
    data() {
        return {
            options: [],
            value: '86',
            tips1: this.$t("phone.input"),
            tips2: this.$t("phone.inputcode"),
            phone: '',
            timer: '',
            codeStatus: false,
            countdown: 600,
            code: '',
            iconShow: false
        };
    },
    mounted() {
        this.getPhoneCode()
    },
    methods: {
        openIconShow() {
            this.iconShow = !this.iconShow
        },
        changeValue(item) {
            this.value = item
            this.iconShow = false
        },
        getPhoneCode() {
            phoneCode().then((res) => {
                if (res.code == "200") {

                    this.options = res.data;
                }
            });
        },
        getCode() {
            if (this.codeStatus) {
                return
            }
            if (this.phone && this.value) {
                getSms({ phone: this.phone, phoneCode: this.value }).then((res) => {
                    if (res.code == "200") {
                        this.$toast.success(this.$t("phone.success"));
                        this.codeStatus = true
                        this.timer = setInterval(() => {
                            if (this.countdown > 0) {
                                this.countdown = this.countdown - 1
                            } else {
                                this.codeStatus = false
                                clearInterval(this.timer)
                                this.countdown = 600
                            }
                        }, 1000)
                    } else {
                        this.$toast(res.msg);
                    }
                });
            } else {
                this.$toast(this.$t("phone.details"));
            }
        },
        toBind() {
            if (this.phone && this.value) {
                if (this.code) {
                    bindPhone({ phone: this.phone, phoneCode: this.value, smsCode: this.code }).then((res) => {
                        if (res.code == "200") {
                            this.$toast.success(this.$t("phone.bsuccess"));
                            this.$router.go("-1");
                        } else {
                            this.$toast(res.msg);
                        }
                    })
                } else {
                    this.$toast(this.$t("phone.inputcode"));
                }
            } else {
                this.$toast(this.$t("phone.details"));
            }

        },
        toBack() {
            this.$router.go("-1");
        },
    },
};
</script>
<style>
.el-input__inner {
    background: #161414;
    border: unset;
}

.el-select {
    background: #161414;
}

.el-select>.el-input {
    background: #161414;
}

.el-select .el-input__inner {
    padding: 0;
}
</style>
<style lang="scss" scoped>
.select-icon {
    display: flex;
    align-items: center;
    position: relative;

    .select-up {
        position: absolute;
        z-index: 999;
        top: 40px;
        width: 12rem;
        height: 20rem;
        background: #161414;
        border-radius: 0.5rem;
        padding: 0.5rem 0;
        overflow-y: scroll;

        .active {
            color: #FFC400 !important;
        }

        >div {
            padding: 0.5rem 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    >p {
        width: 32px;
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }
}

.login-user {
    width: 100vw;
    height: 100vh;
    background: #0c0b0b;

    .login-main {
        padding: 0 0.9375rem;
    }

    .nowLogin {
        padding: 3.75rem 1.875rem 0;
        margin-bottom: 0.9375rem;
        margin-top: 4.75rem;

        >div {
            width: 100%;
            height: 2.6875rem;
            background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
            border-radius: 1.375rem;
            display: flex;
            align-items: center;
            justify-content: center;

            >p {
                font-size: 0.9375rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #0c0b0b;
            }
        }
    }

    .exchange-number {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 0.25rem;
        height: 2.6875rem;
        background: #161414;
        margin-top: 0.9375rem;

        .left-title {
            width: 10%;
            padding-left: 0.75rem;
            min-width: 4.5rem;
            max-width: 4.5rem;
            font-size: 0.8125rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
        border: unset;
    }

    /deep/ .van-field__control {
        color: #ffffff !important;
    }

    .van-cell {
        background: #161414;
        //border-radius: 1.375rem;
    }

    .van-cell-group {
        background: #161414;
        border-radius: 1.375rem;
    }

    .index-view-top {
        height: 3.625rem;
        padding: 0 0.9375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 1.125rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #ffffff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/user/phone.vue